export default "__VITE_ASSET__BTzceUOg__"